import { render } from "./HiMarkable.vue?vue&type=template&id=9ccce0a0"
import script from "./HiMarkable.vue?vue&type=script&lang=js"
export * from "./HiMarkable.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__